import styled from 'styled-components';

export const ContentWrapper = styled.div`
    width: 100%;
    height: 40%;
    margin-top: 20px;
    flex: 1;
    min-height: 0;
    overflow: auto;
    display: flex;
    flex-direction: column;
    scrollbar-width: none;
    -ms-overflow-style: none;

    ::-webkit-scrollbar {
        display: none;
    }
`;

export const ContentRowWrapper = styled.div`
    margin-bottom: 2rem;
`;

export const ContentRowTitle = styled.div`
    color: white;
    margin: 0.5rem 0;
    font-size: 1.8rem;
    font-weight: 700;
    padding-left: 3rem;
`;

export const ContentRowScrollingWrapper = styled.div`
    overflow-x: auto;
    overflow-y: hidden;
    flex-shrink: 1;
    flex-grow: 1;
    padding-left: 3rem;
    padding-right: 3rem;
`;

export const ContentRowScrollingContent = styled.div`
    display: flex;
    flex-direction: row;
    padding-right: 3rem;
    margin-right: 3rem;
`;

export const PlaylistSection = styled.div`
    margin-bottom: 40px;
    scroll-margin-top: 20px;
`;

export const Title = styled.div`
    font-size: 2rem;
    font-weight: bolder;
    margin-bottom: 10px;
`;

export const Row = styled.div`
    min-width: 100%;
    display: flex;
    overflow-x: hidden;
    position: relative;
`;

export const Col = styled.div`
    width: 300px;
    margin: 10px;
    flex-shrink: 0;
`;

export const ThumbnailCard = styled.div<{$focused: boolean}>`
    background-color: #1e1e1e;
    border-radius: 8px;
    overflow: hidden;
    transition: transform 0.2s;
    cursor: pointer;
    border: ${({$focused}) => ($focused ? '4px solid white' : '2px solid transparent')};

    &:hover {
        transform: translateY(-4px);
    }
`;

export const ThumbnailImage = styled.img`
    width: 100%;
    height: 150px;
    display: block;
`;

export const VideoTitle = styled.div`
    font-size: 20px;
    font-weight: 600;
    padding: 8px 12px;
    line-height: 1.4;
`;

export const DownloadBtn = styled.button<{$focused?: boolean}>`
    position: relative;
    width: 100%;
    background: none;
    border: 2px solid #3ab8ff;
    color: white;
    font-weight: bold;
    border-radius: 6px;
    padding: 8px 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-bottom: 20px;
    overflow: hidden;

    &:hover {
        background-color: #3ab8ff;
        color: #000;
    }

    ${(props) =>
        props.$focused &&
        `
        background-color: #00bfff !important;
        color: #000 !important;
        box-shadow: 0 0 10px rgba(0, 191, 255, 0.5);
        transform: scale(1.05);
    `}
`;

export const ProgressBarFill = styled.div<{$progress: number}>`
    position: absolute;
    left: 0;
    bottom: 0;
    width: ${(props) => props.$progress}%;
    height: 4px;
    background: #00ff7f;
    border-radius: 0 0 4px 4px;
    transition: width 0.1s linear;
`;

export const VideoDate = styled.div`
    font-size: 12px;
    color: #aaa;
    padding: 0 12px 12px;
`;

export const GoDownloadWrapper = styled.button<{$focused?: boolean}>`
    position: absolute;
    top: 20px;
    left: 90rem;
    width: 400px;
    background: none;
    border: 2px solid #3ab8ff;
    color: white;
    font-weight: bold;
    border-radius: 6px;
    padding: 8px 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-bottom: 20px;
    overflow: hidden;

    &:hover {
        background-color: #3ab8ff;
        color: #000;
    }

    ${(props) =>
        props.$focused &&
        `
        background-color: #00bfff !important;
        color: #000 !important;
        box-shadow: 0 0 10px rgba(0, 191, 255, 0.5);
        transform: scale(1.05);
    `}
`;

export const SlideContainer = styled.div<{$isSlided: boolean}>`
    display: flex;
    width: 200vw;
    transform: translateX(${({$isSlided}) => ($isSlided ? '-100vw' : '0')});
    transition: transform 0.4s ease-in-out;
`;

export const MainContent = styled.div`
    width: 100vw;
    min-width: 100vw;
    display: flex;
    flex-direction: column;
`;

export const DownloadContent = styled.div`
    width: 1860px;
    height: 925px;
`;
